"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ZoomInIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M11.436 9.436h1.856c.337 0 .644.195.787.5.148.317.148.683 0 1a.869.869 0 01-.787.5h-1.856v1.856a.869.869 0 01-.5.787 1.178 1.178 0 01-1 0 .869.869 0 01-.5-.787v-1.856H7.834a.869.869 0 01-.786-.5 1.178 1.178 0 010-1c.143-.305.45-.5.786-.5h1.602V7.834c0-.337.195-.643.5-.786a1.178 1.178 0 011 0c.305.143.5.45.5.786v1.602zm9.937 11.273a.934.934 0 01-.52.554 1.5 1.5 0 01-1.86-.21l-3.96-3.96a8 8 0 112.11-2.133l3.972 3.972a1.5 1.5 0 01.258 1.777zm-6.975-6.373a5.5 5.5 0 10-7.779-7.778 5.5 5.5 0 007.779 7.778z"
  }));
});
ZoomInIcon.category = 'Action';
var _default = ZoomInIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@mineral/icons/build/ZoomInIcon.js
// module id = 1175
// module chunks = 0